import { takeEvery, call, put, all, select } from 'redux-saga/effects';
import {
  requestInProcess,
  requestFinished,
  updateList,
  sendRequest,
  selectQueryParams
} from '../../../../../../common/reducers/list/reducer';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserReferralService from '../../../../services/UserReferralService';

function* getUserReferralsAuthUser(reducerName) {
  yield put(requestInProcess(reducerName));
  const queryParams = yield select(selectQueryParams, reducerName);
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      UserReferralService.getUserReferralsAuthUser,
      queryParams
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.status) {
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.itemsById,
            itemsIds: result.destructData.itemsIds,
            pagination: result.destructData.pagination,
            total: result.destructData.total
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function* createSaga(reducerName) {
  yield all([
    takeEvery(
      sendRequest(reducerName).type,
      getUserReferralsAuthUser,
      reducerName
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userReferral/reducers/static/lists/sagas/userReferralStatSaga.js